let lazyLoadObserver = null

export default function initLazyLoad() {
	lazyLoadObserver?.disconnect()
	lazyLoadObserver = null

	const lazyLoadArray = Array.from(document.querySelectorAll('img[data-srcset]'))

	if (!lazyLoadArray.length) return

	if (!('IntersectionObserver' in window)) {
		lazyLoadArray.forEach(lazyLoad)
		return
	}

	const options = {
		root: null,
		threshold: 0,
		rootMargin: '20%',
	}
	const observer = new IntersectionObserver(function (entries) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return
			}
			lazyLoad(entry.target)
			observer.unobserve(entry.target)
		})
	}, options)
	lazyLoadObserver = observer

	lazyLoadArray.forEach((item) => {
		observer.observe(item)
	})

	function lazyLoad(item) {
		const img = item

		// SRCSET
		const imgSrcset = img.getAttribute('data-srcset')
		if (imgSrcset) {
			img.srcset = imgSrcset
			img.removeAttribute('data-srcset')
		}

		// SIZES
		const imgSizes = img.getAttribute('data-sizes')
		if (imgSizes) {
			img.sizes = imgSizes
			img.removeAttribute('data-sizes')
		}

		img.classList.add('loaded')
	}
}
